var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._t("default",null,{"setTime":_vm.setTime,"toggleAudio":_vm.toggleAudio,"duration":_vm.duration,"rangeTime":_vm.state.currentTime,"isAudioPlaying":_vm.state.isPlay,"formattedRemainingTime":_vm.formattedRemainingTime})],2)}
var staticRenderFns = []

export { render, staticRenderFns }